import React from 'react';
import { NavLink } from 'react-router-dom';
import { Check } from 'lucide-react';
import { marketTopics, topicPath } from '../../data/market/topics';
import { useMarketProgress } from '../../hooks/useMarketProgress';

/** Índice de temas con marca de leído. */
export function MarketTopicList() {
  const {
    isRead
  } = useMarketProgress();
  const groups = [{
    label: 'Temas para jugadores',
    items: marketTopics.filter(t => t.kind === 'user')
  }, {
    label: 'Consulta',
    items: marketTopics.filter(t => t.kind === 'ref')
  }];
  return <nav aria-label="Temas del Vanguard Market" className="space-y-5 print:hidden" data-id="element-1068" data-mp="2qmp9ea5716ci">
      {groups.map(g => <div key={g.label} data-id="element-1069" data-mp="2loxi9icdho9d">
          <p className="mb-1.5 px-3 text-xs font-semibold text-gray-500" data-id="element-1070" data-mp="2go0035rd4u7v">{g.label}</p>
          <ul className="space-y-0.5" data-id="element-1071" data-mp="1a7nzky12j094">
            {g.items.map(t => <li key={t.key} data-id="element-1072" data-mp="1a5l0lohxtws9">
                <NavLink to={topicPath(t)} className={({
            isActive
          }) => `flex items-center justify-between gap-2 rounded-xl px-3 py-2 text-sm transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] ${isActive ? 'bg-white/10 font-semibold text-[#D4AF37]' : 'text-gray-300 hover:bg-white/5 hover:text-white'}`} data-id="element-1073" data-mp="158um35ls798y">
                  <span data-id="element-1074" data-mp="11jzd9ctgjs2m">{t.menu}</span>
                  {isRead(t.key) && <Check className="h-4 w-4 shrink-0 text-emerald-400" aria-label="Leído" data-id="element-1075" data-mp="mw4gnlcbx3k9" />}
                </NavLink>
              </li>)}
          </ul>
        </div>)}
    </nav>;
}